/**
 * Converts seconds to milliseconds
 *
 * @param seconds - Time in seconds.
 * @return milliseconds - Converted time in milliseconds.
 */
var secondsToMilliseconds = function (seconds) { return seconds * 1000; };

export { secondsToMilliseconds };



//////////////////
// WEBPACK FOOTER
// ./node_modules/framer-motion/dist/es/utils/time-conversion.mjs
// module id = TUxP
// module chunks = 0